import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/visa-readiness")({
  head: () => ({
    meta: [
      { title: "AI F-1 Visa Readiness Audit | WeLivdIt" },
      {
        name: "description",
        content:
          "Check your F-1 approval odds with WeLivdIt's AI visa readiness audit - profile scoring, 214(b) red flags and DS-160 consistency checks.",
      },
      { property: "og:title", content: "AI F-1 Visa Readiness Audit | WeLivdIt" },
      {
        property: "og:description",
        content: "Score your F-1 profile, spot 214(b) red flags and fix DS-160 inconsistencies before your interview.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: VisaReadinessLayout,
});

function VisaReadinessLayout() {
  return <Outlet />;
}
